// components/PersonalDetailTable.jsx
import React from 'react';
import { detailTableHeaders } from '../constants/personalConstants';
import '../StatisticaPersonal.css';

const PersonalDetailTable = ({ data, kgNumber, onBack, loading }) => {
    if (loading) {
        return (
            <div className="loading-container">
                <div className="spinner"></div>
                <p>Завантаження деталей...</p>
            </div>
        );
    }

    if (!data || data.length === 0) {
        return (
            <div className="no-data-message">
                Не має інформації в обраному періоді
            </div>
        );
    }

    return (
        <div className="table-container">
            <div className="back-button-section">
                <button className="back-button" onClick={onBack}>
                    ← Повернутись до списку
                </button>
            </div>

            <div className="table-header">
                <p className="reg-title">
                    Інформація щодо працівників в ЗДО {kgNumber} станом на {new Date().toLocaleDateString('uk-UK')}
                </p>
            </div>
            
            <div className="table-responsive">
                <table className="table table-striped">
                    <thead>
                        <tr>
                            {detailTableHeaders.map(header => (
                                <th key={header.key} scope="col">{header.label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, i) => {
                            const femSex = item['Жінка'] || 0;
                            const maleSex = item['Чоловік'] || 0;

                            return (
                                <tr key={i}>
                                    <td>{i + 1}</td>
                                    <td>{item.nameOfPos}</td>
                                    <td>{maleSex}</td>
                                    <td>{femSex}</td>
                                    <td>{femSex + maleSex}</td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PersonalDetailTable;